"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const v1 = {
    label: 'I consent to this interview being **recorded** and **analyzed by AI** ' +
        'to help evaluate my responses. A human reviews the assessment and ' +
        'makes the final hiring decision. My data may be retained for up to 1 year.',
    lastUpdated: '2026-05-19',
    modalSections: [
        {
            heading: "What's recorded",
            body: 'Your audio, a transcript of your responses, and basic session ' +
                'data (e.g., timestamps).',
        },
        {
            heading: 'What the AI does',
            body: 'Analyzes your responses to assess your fit for the role — ' +
                'including the content of your answers and how your experience ' +
                "aligns with the role's requirements.",
        },
        {
            heading: "What the AI doesn't do",
            body: 'It does not evaluate your appearance, accent, or any protected ' +
                'characteristic. It does not make hiring decisions — a human ' +
                "reviews the AI's assessment and decides whether you advance.",
        },
        {
            heading: 'Your data',
            body: '- Stored encrypted; access limited to the hiring team.\n' +
                '- May be retained for up to 1 year after the hiring decision.\n' +
                '- Not sold. Not used to train AI models.',
        },
        {
            heading: 'Your rights',
            body: '- **Decline** this format and request a live interview — this will not affect your application.\n' +
                '- **Access or delete** your recording and assessment at any time.\n' +
                '- **Request human review** of any decision you believe was unfair.\n' +
                '- California candidates have rights under the CCPA.',
        },
        {
            heading: 'Questions or concerns',
            body: 'Contact the hiring team at the email provided in your invitation.',
        },
    ],
};
exports.default = v1;
